<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="12">
        <h1 class="font-weight-bolder mb-0">Odds Boost</h1>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="6" md="3">
        <b-card>
          <b-row>
            <b-col md="12">
              <h4 class="font-weight-bold text-nowrap">Active Boosts</h4>
            </b-col>
            <b-col md="12">
              <div class="d-flex align-items-end">
                <h1 class="text-primary mb-0" style="line-height: 1">12</h1>
                <div class="d-flex align-items-center ml-1">
                  <feather-icon class="text-success" icon="ArrowUpIcon" />
                  <span>2</span>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6" md="3">
        <b-card>
          <b-row>
            <b-col md="12">
              <h4 class="font-weight-bold text-nowrap">Average Boost Value</h4>
            </b-col>
            <b-col md="12">
              <div class="d-flex align-items-end">
                <h1 class="text-primary mb-0" style="line-height: 1">+15%</h1>
                <div class="d-flex align-items-center ml-1">
                  <feather-icon class="text-success" icon="ArrowUpIcon" />
                  <span>3%</span>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="6" md="3">
        <b-card>
          <b-row>
            <b-col md="12">
              <h4 class="font-weight-bold text-nowrap">Boost Usage Rate</h4>
            </b-col>
            <b-col md="12">
              <div class="d-flex align-items-end">
                <h1 class="text-primary mb-0" style="line-height: 1">68.4%</h1>
                <div class="d-flex align-items-center ml-1">
                  <feather-icon class="text-danger" icon="ArrowDownIcon" />
                  <span>1.2% </span>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="8">
        <b-row>
          <b-col cols="12" md="3">
            <label for="From">From</label>
            <flat-pickr
              id="startDate"
              v-model="startDate"
              class="form-control"
              :config="configDate"
              placeholder="mm/dd/yyyy"
            />
          </b-col>
          <b-col cols="12" md="3">
            <label for="To">To</label>
            <flat-pickr
              id="endDate"
              v-model="endDate"
              class="form-control"
              :config="configDate"
              placeholder="mm/dd/yyyy"
            />
          </b-col>
          <b-col cols="12" md="3">
            <b-button
              @click="handleClearFilter"
              variant="outline-secondary"
              class="mt-2"
              >Clear Filter</b-button
            >
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="4" class="text-right justify-center">
        <b-link :to="{ name: 'promotions-odd-boost-new' }">
          <b-button size="md" variant="primary">
            <feather-icon icon="PlusIcon" />
            <span class="text-lg text-nowrap" style="margin-left: 4px"
              >New Odds Boost</span
            >
          </b-button>
        </b-link>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <!-- <b-card> -->
        <b-table
          ref="refPromotionTable"
          class="mt-2"
          :items="fetchPromotionList"
          :fields="tableColumns"
          responsive
          show-empty
          primary-key="campaign"
        >
          <template #empty>
            <div v-if="loadingList" class="text-center text-dark my-2">
              <p>Loading... Please wait</p>
            </div>

            <div
              v-else-if="!loadingList && fetchPromotionList.length === 0"
              class="text-center text-dark my-2"
            >
              No matching records found
            </div>
          </template>

          <template #cell(date)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ format(new Date(item.startTime), "yyyy-MM-dd") }}
              </div>
            </b-media>
          </template>
          <template #cell(expiry)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ format(new Date(item.endTime), "yyyy-MM-dd") }}
              </div>
            </b-media>
          </template>
          <template #cell(name)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ item.name }}
              </div>
            </b-media>
          </template>
          <template #cell(boostAllocated)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ item.boostAllocated }}
              </div>
            </b-media>
          </template>
          <template #cell(category)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ item.category }}
              </div>
            </b-media>
          </template>
          <template #cell(boostAmount)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ formatBoostAmount(item.discountType, item.discountValue) }}
              </div>
            </b-media>
          </template>

          <template #cell(discountType)="{ item }">
            <b-media vertical-align="center">
              <b-badge
                pill
                :variant="convertVariantType(item.discountType)"
                class="text-capitalize"
              >
                {{ item.discountType }}
              </b-badge>
            </b-media>
          </template>
          <template #cell(segments)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                {{ item.segments }}
              </div>
            </b-media>
          </template>
          <template #cell(status)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center text-nowrap">
                <b-form-checkbox
                  :checked="item.status === 'active'"
                  @click.native.prevent="handleCheckboxClick(item)"
                  switch
                />
              </div>
            </b-media>
          </template>

          <template #cell(actions)="{ item }">
            <b-media vertical-align="center">
              <div class="d-flex align-items-center">
                <feather-icon
                  size="16"
                  icon="EditIcon"
                  class="mr-1 text-primary cursor-pointer"
                  @click="$router.push(`/promotions/odd-boost/${item.id}`)"
                />
                <feather-icon
                  size="16"
                  icon="TrashIcon"
                  class="mr-1 text-danger cursor-pointer"
                  @click="showModal('delete', item)"
                />
              </div>
            </b-media>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">
                Showing {{ dataMeta.from }} to {{ dataMeta.to }} of
                {{ dataMeta.of }} boost tokens
              </span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalPromotions"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
        <!-- </b-card> -->
      </b-col>
    </b-row>

    <!-- MODAL CONFIRM -->
    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      :ok-disabled="isSubmitting"
      @ok="handleSubmitModal"
    >
      <b-card-text style="color: black">
        {{ modal.content }}
      </b-card-text>
      <template #modal-ok>
        <Spinner v-if="isSubmitting" />
        <span v-else>Submit</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BLink,
  BCardText,
  BFormCheckbox,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { computed, ref, watch } from "@vue/composition-api";
import useToastHandler from "@/services/toastHandler";
import { mapActions, mapState } from "vuex";
import { endOfDay, format, startOfDay } from "date-fns";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BLink,
    BCardText,
    BFormCheckbox,
    BBadge,
  },
  data() {
    return {
      tableColumns: [
        { key: "date", label: "Date" },
        { key: "expiry", label: "Expiry" },
        { key: "name", label: "Name" },
        { key: "code", label: "Reference Code" },
        { key: "boostAllocated", label: "Boost Allocated" },
        { key: "category", label: "Category" },
        { key: "boostAmount", label: "Boost Amount" },
        { key: "maxDiscount", label: "Max Stake" },
        { key: "discountType", label: "Boost Type" },
        { key: "segments", label: "Profile/Segments" },
        { key: "status" },
        { key: "actions", label: "Actions" },
      ],
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      action: {
        type: "",
        item: "",
      },
      modal: {
        title: "",
        content: "",
      },
      updateStatusItem: null,
    };
  },
  computed: {
    ...mapState("promotions/list", [
      "loadingList",
      "loadingDeletePromotion",
      "loadingCreatePromotion",
    ]),
    isSubmitting() {
      return this.loadingDeletePromotion || this.loadingCreatePromotion;
    },
  },
  methods: {
    ...mapActions({
      getPromotionsList: "promotions/list/getPromotionsList",
      deletePromotion: "promotions/list/deletePromotion",
      getDetailPromotion: "promotions/list/getDetailPromotion",
      updatePromotion: "promotions/list/updatePromotion",
    }),
    async fetchPromotionList() {
      const data = await this.getPromotionsList({
        page: this.currentPage,
        limit: this.perPage,
        type: "Boost",
        ...(!!this.startDate &&
          !!this.endDate && {
            "date[startDate]": startOfDay(
              new Date(this.startDate)
            ).toISOString(),
          }),
        ...(!!this.startDate &&
          !!this.endDate && {
            "date[endDate]": endOfDay(new Date(this.endDate)).toISOString(),
          }),
      });
      this.totalPromotions = data.pagination.total;

      if (!data) return this.showToastError(false, "Error fetching offer list");
      return data.data;
    },
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },

    showModal(type, item) {
      this.action = { item, type };
      if (type === "delete") {
        this.setModal(
          "Delete Promotion",
          `Are you sure you want to delete the promotion ${item.id}?`
        );
      }
      if (type === "status") {
        this.setModal(
          "Update Status Promotion",
          `Are you sure you want to ${
            item.status === "active" ? "inactive" : "active"
          } the promotion ${item.id}?`
        );
        this.fetchDetailPromotion(item);
      }
      this.$refs.modal.show();
    },

    async handleSubmitModal(event) {
      event.preventDefault();
      const { item, type } = this.action;

      if (type === "delete") await this.handleDeletePromotion(item);
      if (type === "status") await this.handleChangeStatusPromotion(item);

      if (!this.isSubmitting) {
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      }
    },
    async handleDeletePromotion(item) {
      const res = await this.deletePromotion(item.id);
      if (res) {
        this.showToastSuccess(true, "Promotion deleted successfully!");
        this.refetchData();
      }
    },
    handleClearFilter() {
      this.startDate = null;
      this.endDate = null;
      this.refetchData();
    },
    handleCheckboxClick(item) {
      this.showModal("status", item);
    },
    async fetchDetailPromotion(item) {
      const { data: data } = await this.getDetailPromotion(item.id);
      this.updateStatusItem = data;
    },
    async handleChangeStatusPromotion(item) {
      const res = await this.updatePromotion({
        promotionId: item.id,
        status: item.status === "active" ? "inactive" : "active",
        name: this.updateStatusItem.name,
        code: this.updateStatusItem.code,
        type: this.updateStatusItem.type,
        subType: this.updateStatusItem.subType,
        discountType: this.updateStatusItem.discountType,
        discountValue: this.updateStatusItem.discountValue,
        maxDiscount: this.updateStatusItem.maxDiscount,
        startTime: this.updateStatusItem.startTime.slice(0, -5),
        endTime: this.updateStatusItem.endTime.slice(0, -5),
        rules: this.updateStatusItem.rules.map((rule) => {
          return {
            conditionType: rule.conditionType,
            conditionValue: rule.conditionValue,
          };
        }),
      });
      if (res) {
        this.showToastSuccess(true, "Promotion updated successfully!");
        this.refetchData();
      }
    },
    convertVariantType(variant) {
      switch (variant) {
        case "amount":
          return "light-success";
        case "percent":
          return "light-primary";
        default:
          return "light-danger";
      }
    },
    formatBoostAmount(type, value) {
      if (type === "percent") {
        return `${value}%`;
      }
      return `${formatCurrencyBuiltInFunc(value)}`;
    },
  },
  setup() {
    const refPromotionTable = ref(null);
    const totalPromotions = ref(0);
    const currentPage = ref(1);
    const perPage = ref(50);

    const startDate = ref(null);
    const endDate = ref(null);

    const dataMeta = computed(() => {
      const localItemsCount = refPromotionTable.value
        ? refPromotionTable.value.localItems.length
        : 0;
      return {
        from:
          perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalPromotions.value,
      };
    });

    const refetchData = () => {
      refPromotionTable.value.refresh();
    };

    watch([currentPage], () => {
      refetchData();
    });

    watch([startDate, endDate], () => {
      if (!!startDate.value && !!endDate.value) {
        refetchData();
      }
    });

    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,
      refPromotionTable,

      totalPromotions,
      currentPage,
      perPage,
      dataMeta,
      refetchData,

      format,
      startDate,
      endDate,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
